{
    "ReportIntervalLanguageFifteenMinutes": "15 minutes",
    "ReportIntervalLanguageThirtyMinutes": "30 minutes",
    "ReportIntervalLanguageOneHour": "1 heure",
    "ReportIntervalLanguageTwoHour": "2 heures",
    "ReportIntervalLanguageTypeMinute": "Procès-verbal",
    "ReportIntervalLanguageTypeHour": "Heure",
    "ReportIntervalLanguageTypeHourPluralised": "Heures",
    "ReportIntervalLanguageInterpolated": "Nombre total d'appels par {} {}",
    "ReportIntervalLanguageCallByInterpolated": "Appels par {} {}",
    "ReportIntervalLanguageCallByNoValueInterpolated": "Appels par {}",
    "ReportIntervalTypeMinutes": "Procès-verbal",
    "ReportIntervalTypeHours": "Heures",
    "ReportIntervalTypeDay": "Jour",
    "ReportIntervalTypeWeek": "Semaine",
    "ReportIntervalTypeMonth": "Mois",
    "NAME": "ReportIntervalLanguage"
}